import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ToursHero from './components/ToursHero';
import IntroVietnam from './components/IntroVietnam';
import ToursGrid from './components/ToursGrid';
import DestinationsGrid from './components/DestinationsGrid';
import TripAdvisorCarousel from './components/TripAdvisorCarousel';
import FAQSection from './components/FAQSection';

export default function ToursPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar dark />

      <main className="flex-1">
        <ToursHero />

        {/* Introduce About Vietnam */}
        <IntroVietnam />

        {/* Tour Packages Grid */}
        <ToursGrid />

        {/* Destinations */}
        <DestinationsGrid />

        {/* TripAdvisor Reviews */}
        <TripAdvisorCarousel />

        {/* FAQ */}
        <FAQSection />
      </main>

      <Footer />
    </div>
  );
}